import {Pagination} from '@mui/material';
import {FC, useEffect, useState} from 'react';
import {useScreenTier} from 'src/hooks/useScreenTier';
import {TablePaginationType} from './TablePagination.types';

export const TablePagination: FC<TablePaginationType> = ({
                                                             totalPages,
                                                             page,
                                                             handleChangePage,
                                                         }) => {
    const {isPhone} = useScreenTier();
    const [currentPage, setCurrentPage] = useState<number>(1);
    useEffect(() => {
        setCurrentPage(page + 1);
    }, [page]);
    const changeCurrentPage = (_event: React.ChangeEvent<unknown>, value: number) => {
        setCurrentPage(value);
        handleChangePage(value - 1);
    };
    return (
        <Pagination
            color="primary"
            count={totalPages}
            page={currentPage}
            onChange={changeCurrentPage}
            // A phone cannot hold nine page buttons and an arrow at each end: there it keeps the
            // first page, the last one, the one you are on and the arrows, and the rest collapses
            // into the ellipsis. These are MUI's own defaults from a tablet up, so nothing moves.
            siblingCount={isPhone ? 0 : 1}
            boundaryCount={1}
            size={isPhone ? 'small' : 'medium'}
        />
    );
};
